const VoucherIcon = ({ className }) => {
	return (
		<svg
			className={className}
			aria-hidden="true"
			xmlns="http://www.w3.org/2000/svg"
			width="24"
			height="24"
			fill="none"
			viewBox="0 0 24 24"
		>
			{/* Ticket outline with concave notches on the left/right edges */}
			<path
				stroke="currentColor"
				strokeWidth="1.6"
				strokeLinecap="round"
				strokeLinejoin="round"
				d="M5 6h14a2 2 0 0 1 2 2v1.5a2.5 2.5 0 0 0 0 5V16a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-1.5a2.5 2.5 0 0 0 0-5V8a2 2 0 0 1 2-2Z"
			/>
			{/* Tear-off perforation */}
			<line
				x1="12"
				y1="7"
				x2="12"
				y2="17"
				stroke="currentColor"
				strokeWidth="1.3"
				strokeDasharray="1.6 1.6"
				strokeLinecap="round"
			/>
		</svg>
	);
};

export default VoucherIcon;
